"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SecondaryUnitTypes = void 0;
var SecondaryUnitTypes;
(function (SecondaryUnitTypes) {
    SecondaryUnitTypes["APT"] = "Apt";
    SecondaryUnitTypes["BSMT"] = "Bsmt";
    SecondaryUnitTypes["BLDG"] = "Bldg";
    SecondaryUnitTypes["DEPT"] = "Dept";
    SecondaryUnitTypes["FL"] = "Fl";
    SecondaryUnitTypes["FRNT"] = "Frnt";
    SecondaryUnitTypes["HNGR"] = "Hngr";
    SecondaryUnitTypes["KEY"] = "Key";
    SecondaryUnitTypes["LBBY"] = "Lbby";
    SecondaryUnitTypes["LOT"] = "Lot";
    SecondaryUnitTypes["LOWR"] = "Lowr";
    SecondaryUnitTypes["OFC"] = "Ofc";
    SecondaryUnitTypes["PH"] = "Ph";
    SecondaryUnitTypes["PIER"] = "Pier";
    SecondaryUnitTypes["REAR"] = "Rear";
    SecondaryUnitTypes["RM"] = "Rm";
    SecondaryUnitTypes["SIDE"] = "Side";
    SecondaryUnitTypes["SLIP"] = "Slip";
    SecondaryUnitTypes["SPC"] = "Spc";
    SecondaryUnitTypes["STOP"] = "Stop";
    SecondaryUnitTypes["STE"] = "Ste";
    SecondaryUnitTypes["TRLR"] = "Trlr";
    SecondaryUnitTypes["UNIT"] = "Unit";
    SecondaryUnitTypes["UPPR"] = "Upper";
    SecondaryUnitTypes["PMB"] = "Pmb";
    SecondaryUnitTypes["#"] = "#";
})(SecondaryUnitTypes = exports.SecondaryUnitTypes || (exports.SecondaryUnitTypes = {}));
